import axios, { AxiosInstance } from 'axios'
import { getGateWay, getHeaderAuth, getToken } from '@/utils/common'

const { ShowERR } = window

// OtherOptions接口
interface OtherOptions {
  autoToast?: boolean;
  duration?: number;
}

/**
 * autoToast 在config 设置autoToast
 *           可控制是否自动弹出错误提示
 *           default: true
 * duration 在config 设置duration
 *           控制弹出错误提示展示时间
 *           default: 2
 */

class HttpRequest {
  private baseUrl: any
  private headers: any
  private autoToast: boolean
  private duration: number

  constructor (baseUrl: any, headers = {}, autoToast = true) {
    this.baseUrl = baseUrl
    // 在参数中配置，是否需要自动弹出错误提示
    this.headers = headers
    this.autoToast = autoToast
    // 消息提示默认2s
    this.duration = 2
  }

  getInsideConfig () {
    return {
      baseURL: this.baseUrl,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json',
        // withCredentials: true,
        ...getHeaderAuth(),
        // authorization: getToken(),
        // ...getGateWay(),
        ...this.headers
      }
    }
  }

  interceptors (instance: AxiosInstance, url: any, otherOptions: OtherOptions) {
    // 请求拦截
    instance.interceptors.request.use(
      (config: any) => {
        // get 方法中可以添加Content-Type, node_modules/axios/lib/adapters/xhr.js :117
        if (config.method.toLowerCase() === 'get') {
          config.data = true
        }
        // json数据处理成fromData
        if (config.iSFromData) {
          let paramStr = ''
          if (Object.prototype.toString.call(config.data) === '[object Object]') {
            for (let it in config.data) {
              paramStr += it + '=' + config.data[it] + '&'
            }
          } else if (Object.prototype.toString.call(config.data) === '[object Array]') {
            for (let i = 0; i < config.data.length; i++) {
              paramStr += (config.data[i].name + '=' + config.data[i].value + '&')
            }
          }
          if (paramStr) {
            paramStr = paramStr.slice(0, -1)
            config.data = paramStr
          }

          config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
        }
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )
    // 响应拦截
    instance.interceptors.response.use(
      (res: any) => {
        // 二进制文件放在前面判断，因为二进制文件没有res.data.code、res.data.msg信息，放在后面可能会有问题
        if (res.request.responseType === 'arraybuffer') {
          return res
        }

        // 某些情况不抛异常
        if (res.config.iframe === true) return res

        // 统一转成Number类型对比
        const {
          data,
          status
        } = res
        // 10000正常 10001登录失效
        if (res && ([10000, 200].includes(Number(res.data.code)) || res.data.status || res.data.success || res.data.state || Array.isArray(res.data))) {
          // 兼容从响应头拿文件下载名称
          let contentDisposition = ''
          let contentType = ''
          if (res.headers['content-disposition'] ) {
             contentDisposition = res.headers['content-disposition']
          }
          if (res.headers['content-type']) {
             contentType = res.headers['content-type']
          }
          return {
            data,
            status,
            contentDisposition,
            contentType
          }
        }
        if (!res.data.state && res.status === 200) {
          // 兼容从响应头拿文件下载名称
          let contentDisposition = ''
          let contentType = ''
          if (res.headers['content-disposition'] ) {
             contentDisposition = res.headers['content-disposition']
          }
          if (res.headers['content-type']) {
             contentType = res.headers['content-type']
          }
          return {
            data,
            status,
            contentDisposition,
            contentType
          }
        }
        // token失效拦截
        if (otherOptions.autoToast) {
          if (res && res.data) {
            const msg = res.data.msg || res.data.message || res.data.errmsg || res.data.errormsg || '请求失败'
            ShowERR(msg, otherOptions.duration)
          }
        }
        return Promise.reject(res)
      },
      (error) => {
        if (error.response && error.response.status && otherOptions.autoToast) {
          ShowERR(`${error.response.statusText} ${error.response.status}`)
        }
        return Promise.reject(error)
      }
    )
  }

  request (options: any) {
    const instance = axios.create({})
    const newOptions = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, newOptions.url, this.setOtherOptions(options))
    return instance(newOptions)
  }

  setOtherOptions (options: any) {
    return {
      autoToast: this.setAutoToast(options),
      duration: this.setDuration(options)
    }
  }

  // 设置自动toast的标志
  setAutoToast (options: any) {
    return typeof options.autoToast !== 'undefined'
      ? !!options.autoToast
      : this.autoToast
  }

  // 弹窗时间
  setDuration (config: any) {
    return typeof config.duration !== 'undefined'
      ? config.duration
      : this.duration
  }
}

export default HttpRequest
